module.exports = __webpack_public_path__ + "img/Site.f9085de0.png";